import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { App } from './App'
import { ApiError } from './api/client'
import './styles/app.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Eine fehlende oder abgelaufene Anmeldung lässt sich durch Wiederholen
      // nicht beheben -- dann wäre jeder Ladevorgang dreimal so langsam.
      retry: (failureCount, error) =>
        !(error instanceof ApiError && error.status < 500) && failureCount < 2,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      // Ohne Netz **scheitern**, nicht anhalten.
      //
      // Von Haus aus hält TanStack Query jede Anfrage an, solange der Browser
      // offline meldet: das Versprechen wird dann nie eingelöst, weder mit
      // Erfolg noch mit Fehler. Das hat hier einen handfesten Schaden
      // angerichtet -- die Vorbereitung eines Fotos wartete auf die
      // Einstellungen, die Anfrage hing, und die Kachel stand für immer auf
      // „…". Das Offline-Verhalten steckt in dieser Anwendung im
      // Ausgangskorb; dafür muss ein Fehlschlag ein Fehlschlag sein.
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Kein Wurzelelement gefunden.')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
